import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}`;

export const guranteeService = {
  create,
  update,
  getById,
  getSuggestion,
  search,
  getAll,
};

function getAll() {
  return fetchWrapper.get(`${baseUrl}/guarantees`);
}

function create(params) {
  return fetchWrapper.post(`${baseUrl}/guarantees`, params);
}

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/guarantees/${id}`, params);
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/guarantees/${id}`);
}

function getSuggestion(params) {
  return fetchWrapper.get(`${baseUrl}/guarantees/suggestion${params}`);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}/guarantees${params}`);
}
